import { useTranslation } from "react-i18next";
import { ITEM_TYPE } from "../AdminPage";
import { Tree } from 'primereact/tree';


export const EntityConfiguration = ({ entity, fieldSelectCallback, selectedItem, isInsertion, dragDropCallback }) => {
    const [t, i18n] = useTranslation();
    const DEFAULT_NODES = [`${ITEM_TYPE.Field}`];
    
    const hasFields = entity.Fields && entity.Fields.length > 0;
    
    const treeItems = [
        {
            key: `${ITEM_TYPE.Field}`,
            label: 'Fields',
            children: isInsertion && selectedItem.type === ITEM_TYPE.Field ? [
                ...entity.Fields.map(f => ({
                    key: `${ITEM_TYPE.Field}-${f.FieldId}`,
                    label: f.Code,
                    data: f,
                })),
                {
                    key: `${ITEM_TYPE.Field}-0`,
                    label: `${t("NgeNewField")}`
                }
            ] : [
                    ...entity.Fields.map(f => ({
                        key:  `${ITEM_TYPE.Field}-${f.FieldId}`,
                        label: f.Code,
                        data: f,
                    }))
            ]
        },
    ]

    const handleFieldSelection = (id) => {
        
        if (DEFAULT_NODES.includes(id) || id === null || id.split("-")[1] === '0' ) {
            return;
        }
        fieldSelectCallback(entity.Fields.find(f => String(f.FieldId) === id.split("-")[1]), ITEM_TYPE.Field);
    }

    const handleDragDrop = (event) => {
        var isValid = true;
        event.value.forEach((item) => {
            const originalItem = treeItems.find(i => i.key === item.key);
            isValid = originalItem?.children?.length === item?.children?.length ?? false;
        })
        if (!isValid) {
            return;
        }
        const fields = event.value.find(i => i.key === String(ITEM_TYPE.Field)).children.map(f => f.label)
        dragDropCallback(fields);
    }

    const selectedKey = selectedItem ? `${selectedItem.type}-${selectedItem.itemId}` : "";

    return (
        <>
            <div>
                {!hasFields ? (
                    <div className="ge-admin-empty" style={{ padding: '40px 20px', textAlign: 'center' }}>
    
                        <p style={{ margin: 0, color: 'var(--color-grey)', fontSize: '12px' }}>
                            Click 'Create Field' to add your first field
                        </p>
                    </div>
                ) : (
                    <Tree
                        className="tree" 
                        filter
                        filterMode="lenient"
                        value={treeItems}
                        selectionMode="single"
                        onSelectionChange={(e) => handleFieldSelection(e.value)} 
                        dragdropScope="demo" 
                        onDragDrop={handleDragDrop}
                        selectionKeys={selectedKey} 
                    />
                )}
            </div>
        </>
    )
}
